import { Badge } from '@indipia/ui-core';
import type { CustReqHistoryItem, CustReqReportSummary } from '../../types/custReqReport.types';
import { CUST_REQ_REPORT_MESSAGE as MSG, countSummary, summaryText, summaryTone } from './custReqReport.logic';

/**
 * 반장 작업보고 이력 카드 아래 고객 요청 블록 — 기획 004 C-3(읽기 전용).
 * '고객 요청 n · 반영 n'(모두 반영 초록 / 아니면 주황) + 요청별 ✓ 반영 / 체크 없음.
 */
export function CustReqHistoryBlock({
  items, summary,
}: {
  items: CustReqHistoryItem[];
  summary: CustReqReportSummary | undefined;
}) {
  if (items.length === 0) return null;
  const sum = summary ?? countSummary(items);

  return (
    <div className="mt-2 border-t border-border pt-2">
      <Badge status={summaryTone(sum)} className="!rounded-full">{summaryText(sum)}</Badge>
      <ul className="mt-2 space-y-1.5">
        {items.map((r) => (
          <li key={r.custReqId} className="min-w-0">
            <p
              className="text-body-sm text-text-secondary"
              style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', whiteSpace: 'pre-line', wordBreak: 'break-word' }}
            >
              {r.content}
            </p>
            <div className="mt-0.5">
              {r.applied
                ? <Badge status="success" className="!rounded-full">✓ {MSG.applied}</Badge>
                : <Badge status="warning" className="!rounded-full">{MSG.noCheckOwner}</Badge>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
